import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sevanseatercaronrent() {



    const cardData = {

keyword: "7 Seater Car on Rent in Pune",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable 7 Seater Car on Rent in Pune for family trips, airport transfers, corporate travel, weekend getaways, and outstation journeys. We provide well-maintained 7-seater vehicles like Ertiga, Innova, and similar models with spacious seating, powerful AC, clean interiors, and experienced chauffeurs. With doorstep pickup across Pune, flexible rental plans, 24/7 availability, one-way and round-trip options, and transparent pricing, we ensure a smooth and comfortable travel experience for small and medium-sized groups.",

topPlaces: [
    
    {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. A 7-seater car is perfect for family darshan trips, offering a smooth and peaceful highway journey from Pune with comfort and privacy."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual city known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. 7-seater cars are ideal for small groups combining pilgrimage and leisure travel from Pune with comfort and convenience."
    },
    {
        title: "Pune Airport Transfers",
        description:
            "7-seater cars are widely used for Pune airport pickup and drop services, offering extra luggage space and comfortable seating for families and groups traveling together with timely and reliable service."
    },
    {
        title: "Alibaug Beach Weekend Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. A 7-seater car is perfect for family beach vacations and weekend trips from Pune with a comfortable and private travel experience."
    },
    {
        title: "Bhimashankar Jyotirlinga Visit",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forest. 7-seater cars provide a safe and comfortable journey for devotees and nature lovers traveling from Pune."
    },
    {
        title: "Lonavala & Khandala Family Trip",
        description:
            "Lonavala and Khandala are the most popular hill stations near Pune, known for waterfalls, green valleys, and scenic viewpoints. A 7-seater car is ideal for small families and groups who want a comfortable and private weekend getaway with flexible travel and scenic monsoon drives."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberry farms, viewpoints, and cool climate. 7-seater cars provide comfortable seating for families exploring lakes, viewpoints, and natural attractions in a relaxed travel experience."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. 7-seater cars are ideal for small family spiritual tours, offering comfort, flexibility, and convenient travel from Pune."
    },
    {
        title: "Lavasa Hill City Visit",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside views, architecture, and scenic roads. 7-seater cars are perfect for short family trips and leisure drives in a relaxed environment."
    },
    {
        title: "Outstation Family Travel",
        description:
            "7-seater cars are a popular choice for outstation travel from Pune due to their balance of space, comfort, and affordability. They are ideal for medium-distance trips across Maharashtra for families and small groups."
    }
],



services: [
{
name: "7 Seater Car on Rent in Pune",
description: "Rising Cab Service offers 7 Seater Car on Rent in Pune for comfortable and spacious travel for families, groups, and business trips. Our fleet includes Ertiga, Innova, Kia Carens, and other premium 7-seater vehicles that are clean, AC-enabled, and well-maintained. We provide professional chauffeurs, doorstep pickup, 24x7 availability, and transparent pricing with no hidden charges. Whether it is local travel, airport transfers, or long-distance outstation journeys, our 7-seater cars ensure a smooth, safe, and comfortable ride for all passengers in and around Pune."
},
{
name: "7 Seater Car for Rent in Pune",
description: "Book 7 Seater Car for Rent in Pune with Rising Cab Service for reliable and spacious transportation. Ideal for family outings, group travel, and airport transfers, our 7-seater vehicles offer comfort, safety, and ample luggage space. With experienced drivers and flexible booking options, we ensure a hassle-free travel experience across Pune and nearby destinations."
},
{
name: "7 Seater Car Rental in Pune",
description: "Rising Cab Service provides 7 Seater Car Rental in Pune for both local and outstation travel needs. Our well-maintained MPVs like Innova, Ertiga, and Kia Carens offer smooth rides with AC comfort and professional chauffeur service. We guarantee timely pickups, affordable rates, and 24x7 support for all types of travel requirements."
},
{
name: "7 Seater Cars Pune Rent",
description: "Find 7 Seater Cars on Rent in Pune with Rising Cab Service for flexible and convenient travel solutions. Our fleet is suitable for families and groups looking for comfortable rides with spacious seating, clean interiors, and reliable drivers. We ensure safe and economical travel for city and highway journeys."
},
{
name: "7 Seater Innova on Rent in Pune",
description: "Book 7 Seater Innova on Rent in Pune for premium comfort and smooth travel experience. The Innova is ideal for long-distance journeys, offering spacious seating, excellent suspension, and professional chauffeur-driven service for family and corporate trips."
},
{
name: "7 Seater Self Drive Car on Rent in Pune",
description: "Rising Cab Service also offers 7 Seater Self Drive Car on Rent in Pune for customers who prefer independent travel. Choose from well-maintained MPVs like Ertiga and Innova for flexible travel without a driver. Enjoy privacy, comfort, and freedom for your journeys across Maharashtra."
},
{
name: "7 Seater Ertiga Car on Rent in Pune",
description: "Book 7 Seater Ertiga Car on Rent in Pune for budget-friendly and comfortable travel. The Ertiga is perfect for families and small groups, offering fuel efficiency, AC comfort, and smooth rides for both city and outstation trips."
},
{
name: "7 Seater Car on Rent in Pimpri Chinchwad",
description: "Rising Cab Service provides 7 Seater Car on Rent in Pimpri Chinchwad for convenient local and outstation travel. Our service ensures quick pickup, clean vehicles, and professional drivers for safe and comfortable journeys across PCMC and Pune."
},
{
name: "Pune to Mahabaleshwar 7 Seater Car Rental",
description: "Book Pune to Mahabaleshwar 7 Seater Car Rental for a comfortable hill station trip with family or friends. Our AC MPVs ensure smooth ghat driving, scenic travel, and professional chauffeur service for a relaxing weekend getaway."
},
{
name: "Pune to Shirdi 7 Seater on Rent",
description: "Rising Cab Service offers Pune to Shirdi 7 Seater on Rent for a spiritual and comfortable journey to Sai Baba’s shrine. Enjoy safe highway travel, clean vehicles, and experienced drivers for a hassle-free pilgrimage experience."
},
{
name: "Pune to Shirdi Cab Package",
description: "Book Pune to Shirdi Cab Package with Rising Cab Service for a complete travel solution including pickup, drop, and flexible darshan travel. Our 7-seater vehicles ensure comfort and affordability for families and groups."
},
{
name: "Pune to Mumbai 7 Seater Cab on Rent",
description: "Rising Cab Service provides Pune to Mumbai 7 Seater Cab on Rent for fast and comfortable intercity travel. Our vehicles ensure smooth highway rides, timely pickup, and professional chauffeur service for business and personal trips."
},
{
name: "Family Car Rental Pune",
description: "Book Family Car Rental in Pune with Rising Cab Service for safe and spacious travel solutions. We offer 7-seater MPVs ideal for family outings, airport transfers, and outstation trips with comfort and reliability."
},
{
name: "7 Passenger Vehicle Rental Pune",
description: "Rising Cab Service offers 7 Passenger Vehicle Rental in Pune for group travel with comfortable seating, AC comfort, and experienced drivers ensuring safe and smooth journeys."
},
{
name: "Pune 7 Seater Cab Booking",
description: "Book Pune 7 Seater Cab Booking with Rising Cab Service for quick, reliable, and affordable transportation. We provide instant confirmation, professional drivers, and clean vehicles for all travel needs."
},
{
name: "Outstation 7 Seater Cab Pune",
description: "Rising Cab Service provides Outstation 7 Seater Cab from Pune for long-distance travel across Maharashtra and nearby states. Enjoy comfortable rides, transparent pricing, and safe journeys with experienced chauffeurs."
},
{
name: "Airport Transfer 7 Seater Pune",
description: "Book Airport Transfer 7 Seater in Pune for convenient airport pickup and drop services. Our spacious MPVs ensure comfortable seating, luggage space, and timely service for stress-free airport travel."
},
{
name: "Maruti Suzuki Ertiga on Rent in Pune",
description: "Rising Cab Service offers Maruti Suzuki Ertiga on Rent in Pune for affordable and efficient family travel. The Ertiga provides excellent mileage, comfort, and AC convenience for city and outstation trips."
},
{
name: "Kia Carens on Rent in Pune",
description: "Book Kia Carens on Rent in Pune for premium 7-seater comfort with modern features and spacious interiors. Ideal for family travel, airport transfers, and long-distance journeys with smooth driving experience."
},
{
name: "Ertiga Cab Service Pune",
description: "Rising Cab Service provides Ertiga Cab Service in Pune for budget-friendly and comfortable group travel. Our AC Ertiga vehicles are perfect for local trips, airport transfers, and outstation journeys."
},
{
name: "Kia Carens Cab Booking Pune",
description: "Book Kia Carens Cab Booking in Pune for a premium travel experience with spacious seating, AC comfort, and professional chauffeur-driven service for all types of travel needs."
},
{
name: "Family MPV Rental Pune",
description: "Rising Cab Service offers Family MPV Rental in Pune for safe and comfortable group travel. Choose from Innova, Ertiga, and Kia Carens for reliable and spacious journeys."
},
{
name: "AC Ertiga on Rent Pune",
description: "Book AC Ertiga on Rent in Pune for comfortable and air-conditioned travel at affordable rates. Ideal for families and small groups traveling within city or outstation routes."
},
{
name: "Kia Carens Outstation Cab Pune",
description: "Rising Cab Service provides Kia Carens Outstation Cab in Pune for long-distance journeys with premium comfort, smooth rides, and professional drivers ensuring safe travel."
},
{
name: "Premium 7 Seater Cab Pune",
description: "Book Premium 7 Seater Cab in Pune for luxury group travel with high comfort, spacious interiors, and experienced chauffeurs for a superior travel experience."
}
],

tableData: [
["7 Seater Car on Rent in Pune","7 Seater Car for Rent in Pune"],
["7 Seater Car Rental in Pune","7 Seater Cars Pune Rent"],
["7 Seater Innova on Rent in Pune","7 Seater Ertiga Car on Rent in Pune"],
["7 Seater Self Drive Car on Rent in Pune","7 Seater Car on Rent in Pimpri Chinchwad"],
["Pune to Mahabaleshwar 7 Seater Car Rental","Pune to Shirdi 7 Seater on Rent"],
["Pune to Mumbai 7 Seater Cab on Rent","Family Car Rental Pune"],
["Pune 7 Seater Cab Booking","Outstation 7 Seater Cab Pune"],
["Airport Transfer 7 Seater Pune","Maruti Suzuki Ertiga on Rent in Pune"],
["Kia Carens on Rent in Pune","Premium 7 Seater Cab Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Affordable 7 Seater Car on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service provides comfortable 7 Seater car rental services in Pune for family trips, airport transfers, corporate travel, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Perfect Vehicle for Family Travel",
        WhyChoosedescription: "A 7 Seater car is an ideal choice for families, relatives, and small groups looking for spacious and comfortable travel together."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Trips",
        WhyChoosedescription: "Our 7 Seater vehicles are available for Pune city travel as well as destinations including Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, Kolhapur, and Lonavala."
    },
    {
        WhyChooseheading: "Spacious Seating with Ample Luggage Capacity",
        WhyChoosedescription: "Passengers enjoy comfortable seating arrangements, sufficient legroom, and luggage space, making long-distance travel convenient."
    },
    {
        WhyChooseheading: "Popular 7 Seater Vehicles Available",
        WhyChoosedescription: "Choose from Ertiga, Kia Carens, Innova, Innova Crysta, and other premium 7 Seater vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby areas."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a smooth travel experience."
    },
    {
        WhyChooseheading: "Best Choice for Tours, Events, and Airport Transfers",
        WhyChoosedescription: "7 Seater vehicles are widely preferred for family vacations, wedding transportation, airport pickups, corporate visits, and pilgrimage tours."
    }
]
};

const faqData = [
    {
        question: "Which 7 Seater cars are available on rent in Pune?",
        answer: "Popular options include Ertiga, Kia Carens, Toyota Innova, Innova Crysta, and other spacious family vehicles."
    },
    {
        question: "Can I hire a 7 Seater car for outstation travel?",
        answer: "Yes, 7 Seater vehicles are available for outstation destinations across Maharashtra and other states."
    },
    {
        question: "Is a 7 Seater suitable for family vacations?",
        answer: "Yes, it offers comfortable seating and luggage space, making it ideal for family trips and holidays."
    },
    {
        question: "Do you provide 7 Seater cars for airport transfers?",
        answer: "Yes, we provide Pune Airport and Mumbai Airport pickup and drop services using 7 Seater vehicles."
    },
    {
        question: "Can I book a 7 Seater for one-way travel?",
        answer: "Yes, both one-way and round-trip bookings are available."
    },
    {
        question: "Are the vehicles air-conditioned?",
        answer: "Yes, all our 7 Seater rental vehicles come with air conditioning for passenger comfort."
    },
    {
        question: "Can corporate clients hire 7 Seater vehicles?",
        answer: "Yes, 7 Seater vehicles are suitable for executive travel, employee transportation, and business trips."
    },
    {
        question: "Do you provide vehicles for pilgrimage tours?",
        answer: "Yes, 7 Seater cars are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, and Jyotirlinga tours."
    },
    {
        question: "Can I book a 7 Seater car for wedding functions?",
        answer: "Yes, these vehicles are frequently hired for family functions, weddings, and guest transportation."
    },
    {
        question: "How can I book a 7 Seater Car on Rent in Pune?",
        answer: "Bookings can be made through phone calls, WhatsApp, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Pawar",
        feedback:
            "We rented an Ertiga for our family trip to Mahabaleshwar. The vehicle was spacious, comfortable, and perfect for our travel needs.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Smita Joshi",
        feedback:
            "The 7 Seater vehicle was clean and well-maintained. Our airport transfer and family outing were handled smoothly and professionally.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "7 Seater Car on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/7-seater-car-pune.jpg",
"description": "Book 7 Seater Car on Rent in Pune with Rising Cab Service for family trips, airport transfers, and outstation travel. Choose Innova, Ertiga, and other 7-seater AC cars with professional drivers for safe and comfortable journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/7-seater-car-on-rent-in-pune"
}
};







    return (
        <div>
<Helmet>
  <title>7 Seater Car on Rent in Pune | Innova & Ertiga Rental | +91 9272511548</title>

<meta
 name="description"
 content="Book 7 Seater Car on Rent in Pune for family trips, airport transfers, and outstation travel. Get Innova, Ertiga, and AC 7-seater cars with driver."
/>

<meta
 name="keywords"
 content="7 seater car on rent in pune, 7 seater car rental pune, 7 seater innova on rent pune, 7 seater ertiga on rent pune, 7 seater car pimpri chinchwad, 7 passenger vehicle rental pune, pune to shirdi 7 seater cab, pune to mahabaleshwar 7 seater car, pune to mumbai 7 seater cab, family car rental pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sevanseatercaronrent;